export const android = require("./android.svg");
export const debian = require("./debian.png");
export const kdeNeon = require("./kdeneon.png");
export const kubuntu = require("./kubuntu.png");
export const linuxMint = require("./linux-mint.png");
export const manjaro = require("./manjaro.png");
export const microsoft = require("./microsoft.png");
export const ubuntu = require("./ubuntu.png");
